// extracted by mini-css-extract-plugin
export default {"form":"Form_form__mCb8F","row":"Form_row__t5tEA","button":"Form_button__KxN6O","required":"Form_required__2tZxr"};